import React, { useCallback } from 'react';
import {
  Card, Container, Table, TableBody, TableCell, TableContainer,
  TablePagination, TableRow,
} from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import {
  CommonListHead, CommonListToolbar, HeaderBreadcrumbs, Page, Scrollbar, SearchNotFound,
} from '../../../components';
import { CONTACT_MESSAGES_HEAD_LIST } from './constants';
import { useStore, useSearch } from '../../../hooks';
import { PATH_DASHBOARD } from '../../../app';
import { useSorting } from '../../../hooks/useSorting';
import { ContactUsItem } from './ContactUsItem';

export const ContactUsList: React.FC = observer(() => {
  const {
    contactUs: {
      items, meta, fetchContactMessages,
    },
  } = useStore();

  const {
    sort, order, orderBy, onClickSorting,
  } = useSorting();

  const handlePageChange = useCallback(
    (_: unknown, newPage: number): void => {
      setPage(newPage);
    },
    [],
  );

  const { searchValue, setSearchValue, debouncedSearchValue } = useSearch();

  const [page, setPage] = React.useState<number>(0);

  React.useEffect(() => {
    fetchContactMessages({ sort, page: page + 1, name: debouncedSearchValue });
  }, [sort, page, debouncedSearchValue]);

  return (
    <Page title="Contact Us Messages">
      <Container maxWidth={false}>
        <HeaderBreadcrumbs
          heading="Contact Us Messages"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Contact Us Messages' },
          ]}
        />
        <Card>
          <CommonListToolbar searchValue={searchValue} onSearch={setSearchValue} placeholder="Search by name..." />
          <TableContainer>
            <Scrollbar>
              <Table>
                <CommonListHead
                  headListData={CONTACT_MESSAGES_HEAD_LIST}
                  order={order}
                  orderBy={orderBy}
                  onClick={onClickSorting}
                />
                <TableBody>
                  {items.length ? items.map((item) => (
                    <ContactUsItem
                      key={`contact-us-${item.id}`}
                      data={item}
                    />
                  )) : (
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={meta.totalItems}
            rowsPerPage={meta.itemsPerPage}
            page={page}
            onPageChange={handlePageChange}
          />
        </Card>
      </Container>
    </Page>
  );
});
